var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckInGreenTick(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#3EAF3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1761 19.9532L9.88195 16.6591C9.79581 16.5719 9.69322 16.5027 9.58013 16.4555C9.46703 16.4082 9.34569 16.3839 9.22312 16.3839C9.10056 16.3839 8.97921 16.4082 8.86612 16.4555C8.75303 16.5027 8.65044 16.5719 8.5643 16.6591C8.47711 16.7453 8.40788 16.8478 8.36064 16.9609C8.31339 17.074 8.28906 17.1954 8.28906 17.3179C8.28906 17.4405 8.31339 17.5619 8.36064 17.6749C8.40788 17.788 8.47711 17.8906 8.5643 17.9768L12.5078 21.9203C12.8749 22.2874 13.4678 22.2874 13.8349 21.9203L23.8114 11.9532C23.8985 11.8671 23.9678 11.7645 24.015 11.6514C24.0623 11.5383 24.0866 11.417 24.0866 11.2944C24.0866 11.1718 24.0623 11.0505 24.015 10.9374C23.9678 10.8243 23.8985 10.7217 23.8114 10.6356C23.7252 10.5484 23.6226 10.4792 23.5095 10.4319C23.3964 10.3847 23.2751 10.3604 23.1525 10.3604C23.03 10.3604 22.9086 10.3847 22.7955 10.4319C22.6824 10.4792 22.5799 10.5484 22.4937 10.6356L13.1761 19.9532Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckInGreenTick);
export default __webpack_public_path__ + "static/media/CheckInGreen Tick.f1a797282d27bbb05285a2a907369658.svg";
export { ForwardRef as ReactComponent };